// @flow

import * as React from 'react';
import {BodyMono} from 'sail/Text';

const Help = () => (
  <BodyMono color="gray200">
    <pre>
      {`
The official command-line tool to interact with Stripe.

Usage:
  stripe [command]

Webhook commands:
  listen                        Listen for webhook events
  trigger                       Trigger test webhook events

Resource commands:
  accounts                      Make requests (retrieve, update, list, etc) on accounts
  charges                       Make requests (capture, create, list, etc) on charges
  customers                     Make requests (create, delete, list, etc) on customers
  payment_intents               Make requests (cancel, capture, confirm, etc) on payment intents
  ...                           To see more resource commands, run \`stripe --help\`

Flags:
  -h, --help                  help for stripe

Use "stripe [command] --help" for more information about a command.
    `.trim()}
    </pre>
  </BodyMono>
);

export default Help;
